import { tokenCodec, PATIENT_TOKENS } from './plainTemplate'

// The confirmation is one sentence with no branches, so the box holds the
// whole template. Its vocabulary is its own: the appointment just booked, and
// no link or requested day.
export const CONFIRMATION_TOKENS = [
  ...PATIENT_TOKENS,
  // Appointment::Reschedule::ConfirmationContext prints them this way.
  { label: 'New day', variable: 'appointment.day', sample: 'Friday, Sep 4' },
  { label: 'New time', variable: 'appointment.time', sample: '10:30 AM' },
]

const { toLiquid, fromLiquid, preview } = tokenCodec(CONFIRMATION_TOKENS)

export { preview }

export const compile = text => toLiquid(text)

// The plain text of a template, or null when it has logic of its own (a tag,
// or a variable without a name here) or would not compile back to the same
// string, so opening and saving the page never rewrites it.
export const parse = template => {
  if ((template || '').includes('{%')) return null

  const plain = fromLiquid(template || '')
  if (plain === null) return null

  return compile(plain) === (template || '') ? plain : null
}
